module.exports = ".banner {\n  padding: 25px;\n}\n\n.banner-small { width: 30vw; height: 30vh; }\n\n.banner-medium {\n  width: 650px;\n  height: 480px;\n}\n\n.banner-full { width: 90vw; height: 90vh; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/banner-editor/stage/banner/banner.component.css
// module id = ./src/app/modules/banner-editor/stage/banner/banner.component.css
// module chunks = main